import {
  setValueBatch,
  useOrderbookStore,
} from 'global/MainLayout/SideWidget/Watchlist/Orderbook/store';
import moment from 'moment';
import { emptyObject } from 'utils/general';

let simulateLivePrice = null;
export const startSimulateLivePrice = () => {
  let i = 0;
  const intr = 10;
  const mock =
    '{"S":"","N":"","M":"","C":{"sym":"IHSG","ohlc":{"Adj_Close":5627.123,"Close":5627.123,"High":5660.385,"Low":5624.928,"Open":5658.199,"volume":5594419200,"date_unix":1492016400,"date_formated":"2017-04-13 00:00:00+07:00","dividend":"","foreign_buy":2145632540293,"foreign_flow":164572124019141,"foreign_sell":1544625382053,"frequency":251951,"marketcap":0,"value":3463678783600,"shareoutstanding":0,"ann_eps":0,"ann_pe":null,"avg_price":null,"previous":5644.15478515625},"widget":{"IHSG":{"lastprice":"5627.123","price_change":"-17.0320","percentage_change":"-0.302"}}},"__t":1492071194520}';
  const mock1 =
    '{"S":"","N":"","M":"","C":{"sym":"INPC","ohlc":{"Adj_Close":102,"Close":102,"High":105,"Low":99,"Open":100,"volume":30281300,"date_unix":1490029200,"date_formated":"2017-03-21 00:00:00+07:00","dividend":"","foreign_buy":0,"foreign_flow":40891563428,"foreign_sell":0,"frequency":4117,"marketcap":1595099574138,"value":3103994400,"shareoutstanding":15796238181,"ann_eps":7.54,"ann_pe":null,"avg_price":102.505,"previous":100},"widget":{"INPC":{"lastprice":"102","price_change":"2","percentage_change":"2"}},"OFFER-RG":{"price9":"111","que_num5":"16","que_num4":"24","que_num7":"8","que_num6":"7","que_num1":"8","que_num3":"27","que_num2":"24","price10":"112","que_num9":"6","que_num8":"15","price7":"109","price8":"110","price5":"107","price6":"108","price3":"105","price4":"106","price1":"103","price2":"104","volume1":"260900","volume3":"1488300","volume2":"1836600","volume5":"2347500","volume4":"1398000","volume7":"359300","volume6":"897900","volume9":"168700","volume8":"320500","que_num10":"6","volume10":"445600"},"BID-RG":{"price9":"94","que_num5":"18","que_num4":"20","que_num7":"6","que_num6":"7","que_num1":"1","que_num3":"18","que_num2":"13","price10":"93","que_num9":"2","que_num8":"4","price7":"96","price8":"95","price5":"98","price6":"97","price3":"100","price4":"99","price1":"102","price2":"101","volume1":"12000","volume3":"1413400","volume2":"1347400","volume5":"1368600","volume4":"628400","volume7":"1025900","volume6":"1013700","volume9":"1300","volume8":"2570300","que_num10":"3","volume10":"16000"}},"__t":1490091253800}';
  const mock_ELSA_C =
    '{"S":"","N":"","M":"","C":{"sym":"ELSA","ohlc":{"Adj_Close":298,"Close":298,"High":308,"Low":298,"Open":300,"volume":74749700,"date_unix":1507136400,"date_formated":"2017-10-05 00:00:00+07:00","dividend":"","foreign_buy":527721600,"foreign_flow":370672302064,"foreign_sell":436602600,"frequency":2761,"marketcap":2174953000000,"value":22664262800,"shareoutstanding":7298500000,"ann_eps":3.96,"ann_pe":null,"avg_price":303.202,"previous":300,"freq_analyzer":3551.4870391264053},"date_unix":1507136400,"widget":{"ELSA":{"lastprice":"308","price_change":"-2","percentage_change":"-0.667"}},"OFFER-RG":{},"BID-RG":{}},"O":"","__t":1507193041035}';
  const mock_ELSA_O =
    '{"S":"","N":"","M":"","C":"","O":{"sym":"ELSA","OFFER-RG":{"price9":"316","que_num5":"107","que_num4":"89","que_num7":"92","que_num6":"140","que_num1":"23","que_num3":"64","que_num2":"28","price10":"318","que_num9":"60","que_num8":"82","price7":"312","price8":"314","price5":"308","price6":"310","price3":"304","price4":"306","price1":"300","price2":"302","volume1":"1785900","volume3":"3128600","volume2":"1936000","volume5":"6448500","volume4":"7207500","volume7":"13696700","volume6":"7946800","volume9":"4039600","volume8":"4784200","que_num10":"45","volume10":"2000700"},"BID-RG":{"price9":"282","que_num5":"67","que_num4":"44","que_num7":"23","que_num6":"25","que_num1":"91","que_num3":"77","que_num2":"86","price10":"280","que_num9":"16","que_num8":"20","price7":"286","price8":"284","price5":"290","price6":"288","price3":"294","price4":"292","price1":"298","price2":"296","volume1":"2541100","volume3":"4919800","volume2":"3998700","volume5":"2428600","volume4":"1747800","volume7":"2508700","volume6":"1376500","volume9":"5917300","volume8":"1047900","que_num10":"33","volume10":"1614000"}},"__t":1507192983176}';
  simulateLivePrice = setInterval(() => {
    i = i + 1;
    let json_mock_C = JSON.parse(mock_ELSA_C);
    let json_mock_O = JSON.parse(mock_ELSA_O);

    let C = json_mock_C.C;
    let O = json_mock_O.O;
    C.__t = json_mock_C.__t;
    O.__t = json_mock_O.__t;

    C.ohlc.High = C.ohlc.High + i;
    C.ohlc.frequency = C.ohlc.frequency + i;
    C.ohlc.Close = C.ohlc.Close + i;
    C.widget['ELSA'].lastprice = Number(C.widget['ELSA'].lastprice) + i;

    O['OFFER-RG'].volume2 = parseInt(O['OFFER-RG'].volume2) + i * 100;
    O['OFFER-RG'].volume3 = parseInt(O['OFFER-RG'].volume3) + i * 100;
    O['OFFER-RG'].volume4 = parseInt(O['OFFER-RG'].volume4) + i * 100;
    O['OFFER-RG'].volume5 = parseInt(O['OFFER-RG'].volume5) + i * 100;
    O['OFFER-RG'].volume6 = parseInt(O['OFFER-RG'].volume6) + i * 100;
    O['OFFER-RG'].volume7 = parseInt(O['OFFER-RG'].volume7) + i * 100;
    O['OFFER-RG'].volume8 = parseInt(O['OFFER-RG'].volume8) + i * 100;
    O['OFFER-RG'].volume9 = parseInt(O['OFFER-RG'].volume9) + i * 100;

    // dispatch(handleC(C))
    handleCSingle(C);
    handleOsingle(O);
  }, intr);
};

export const stopSimulateLivePrice = () => {
  clearInterval(simulateLivePrice);
};

export const handleCSingle = (data, isNATS = false) => {
  let batch = [];
  const state = useOrderbookStore.getState();
  const symbol = isNATS ? data.stockCode : data.sym;
  const general_pricedata = state.liveprice[symbol];
  const checkObj = emptyObject(general_pricedata);
  let page_company_lastupdate = '';
  if (isNATS) {
    page_company_lastupdate = moment(data.date).format('ddd HH:mm');
  } else {
    let temp_timestamp = data.__t.toString();
    temp_timestamp = parseInt(temp_timestamp);
    page_company_lastupdate = moment.unix(temp_timestamp).format('ddd HH:mm');
  }

  if (!checkObj) {
    // if there is symbol
    convertUpdatePriceSocket(data, isNATS, (err, result) => {
      const newResult = { ...result };
      newResult.time = page_company_lastupdate;

      batch.push({
        name: 'update_general_pricedata_liveprice',
        payload: {
          index: symbol,
          data: newResult,
          lastupdate: page_company_lastupdate,
        },
      });
    });
  }

  setValueBatch(batch);
  return batch;
};

export const handleOsingle = (data) => {
  let plate = {
    bid: data['BID-RG'],
    offer: data['OFFER-RG'],
  };

  let batch = [];
  const state = useOrderbookStore.getState();
  const symbol = data.sym;
  const general_pricedata = state.liveprice[symbol];
  const checkObj = emptyObject(general_pricedata);

  if (!checkObj) {
    // if there is symbol
    batch.push({
      name: 'update_orderbook_pricedata_liveprice',
      payload: { index: symbol, data: plate },
    });
  }

  setValueBatch(batch);
};

const convertUpdatePriceSocket = (pricesocket, isNATS, cb) => {
  let convert_spec = {};

  if (isNATS) {
    convert_spec = {
      'BID-RG': 'bid',
      'OFFER-RG': 'offer',
      close: 'close',
      open: 'open',
      high: 'high',
      low: 'low',
      average: 'average',
      prev: 'previous',
      value: 'value',
      volume: 'volume',
      frequency: 'frequency',
      frg_buy: 'fbuy',
      frg_sell: 'fsell',
      stockCode: 'symbol',
      lastprice: 'lastprice',
      change: {
        percentage: 'percentage_change',
        value: 'change',
      },
    };
  } else {
    convert_spec = {
      'BID-RG': 'bid',
      'OFFER-RG': 'offer',
      ohlc: {
        Close: 'close',
        Open: 'open',
        High: 'high',
        Low: 'low',
        avg_price: 'average',
        previous: 'previous',
        value: 'value',
        volume: 'volume',
        frequency: 'frequency',
        foreign_buy: 'fbuy',
        foreign_sell: 'fsell',
      },
      sym: 'symbol',
      widget: {
        sym$: {
          price_change: 'change',
          percentage_change: 'percentage_change',
          lastprice: 'lastprice',
        },
      },
    };
  }

  let result = {};

  result = generalConvertBySpec(convert_spec, pricesocket);
  // @ts-ignore
  // result.id = pricecurrent.id
  // @ts-ignore
  // if (pricecurrent.desc) result.desc = pricecurrent.desc
  cb(null, result);
  return result;
};

const generalConvertBySpec = (convert_spec, pricesocket) => {
  const result = {};
  Object.keys(convert_spec).map((name) => {
    if (typeof convert_spec[name] === 'string') {
      result[convert_spec[name]] = pricesocket[name];
    } else {
      const _convert_spec = convert_spec[name];
      const _pricesocket = pricesocket[name];
      Object.keys(_convert_spec).map((_name) => {
        if (_pricesocket[_name] || _pricesocket[_name] === 0) {
          // if price socket exists
          result[_convert_spec[_name]] = _pricesocket[_name];
        } else if (_name.indexOf('$') !== -1) {
          // if price socket dollar sign
          const ori_name = _name;
          _name = _name.replace('$', '');
          Object.keys(convert_spec).map((name) => {
            if (name === _name) {
              const value = pricesocket[name];
              const obj_temp = _pricesocket[value];
              Object.keys(_convert_spec[ori_name]).map((_child_name) => {
                result[_convert_spec[ori_name][_child_name]] =
                  obj_temp[_child_name];
              });
            }
          });
        }
      });
    }
  });
  return result;
};
